import React from 'react';

const About = () => {
    return (
        <div className="home-challenges-section">
            <div className="raffle-user-view about-container">
                <h2>About BBQ Party</h2>
                <div className="about-content-brown">
                    <p>
                        The whole idea of this website is to make our beloved party more interactable and fun.
                        <br></br>
                        
                        Main idea is that you get paired with another person and you have to complete challenges together.
                        <br></br>

                        Everything is randomized, as the evenings destiny :) 
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About; 